import axios from "axios";
//import { router } from "../router";
import { Message, MessageBox } from "element-ui";
const service = axios.create({
  baseURL: process.env.VUE_APP_OPEN_BASE_API,
  timeout: 10000, //超过10秒后超时提示，默认：5s
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
  withCredentials: true
});

service.interceptors.response.use(
  response => {
    //const status = response.status;

    const res = response.data;

    if (res.code !== "0" && res.code !== 0) {
      MessageBox({
        title: "提示",
        message: res.msg
      });
    }
    return res;
  },
  error => {
    Message({
      message: error.message,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(error);
  }
);

export default service;
